// Upcoming vs past events.
//
// The API sends dates as UTC strings whose digits are the Sydney calendar date
// ("2026-10-24T00:00:00Z" means 24 October in Sydney - see formatEventDate in
// EventDetails.jsx). Compare those date digits with today's date in Sydney.
// Only start_date/end_date are used: start_time/end_time carry unrelated dates.

const sydneyDay = new Intl.DateTimeFormat("en-CA", {
  timeZone: "Australia/Sydney",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// Today's date in Sydney as "YYYY-MM-DD".
export const sydneyToday = (now = new Date()) => sydneyDay.format(now);

// The last day of the event ("YYYY-MM-DD"), or "" if it has no date.
export const eventLastDay = (event) => {
  const venue = event?.event_venue || {};
  const days = [venue.start_date, venue.end_date]
    .map((value) => String(value || "").slice(0, 10))
    .filter((day) => /^\d{4}-\d{2}-\d{2}$/.test(day));
  return days.sort().pop() || "";
};

// Upcoming = the event's last day is today or later. Events stay listed for
// the whole of their final day. Undated events are kept (can't tell).
export const isUpcoming = (event, today = sydneyToday()) => {
  const last = eventLastDay(event);
  return !last || last >= today;
};

// Upcoming events only, soonest first (undated ones last).
export const upcomingEvents = (events = [], today = sydneyToday()) =>
  events
    .filter((event) => isUpcoming(event, today))
    .sort((a, b) => {
      const da = String(a?.event_venue?.start_date || "9999").slice(0, 10);
      const db = String(b?.event_venue?.start_date || "9999").slice(0, 10);
      return da.localeCompare(db);
    });
